import { assertNever } from 'src/replicant/utils';
import { getAccessoryPath } from '../accessories/helpers';
import { getDecorationPath } from '../decoration/helpers';
import { GachaItem } from 'src/replicant/gacha/gacha.ruleset';

/**
 * Get gacha reward icon.
 * @param item - Item.
 */
export function getGachaRewardIcon(reward: GachaItem) {
  const { type } = reward;
  switch (type) {
    case 'decoration':
      return getDecorationPath(reward.image)!;
    case 'accessory':
      return getAccessoryPath(reward.image, reward.tierId);
    default:
      assertNever(type);
  }
}
